import { memo } from 'react';
import SaveJobForSignedIn from './components/SaveJobForSignedIn/SaveJobForSignedIn.tsx';
import SaveJobForSignedOut from './components/SaveJobForSignedOut/SaveJobForSignedOut.tsx';

export interface SaveJobProps {
  isApplied: boolean;
  isAuthenticated: boolean;
  isSaved: boolean;
  isSplitView: boolean;
  jobId: string;
  returnUrl: string;
  toggleSavedJob: (e: React.MouseEvent) => void;
}

const SaveJob = ({
  isAuthenticated,
  isSaved,
  isApplied,
  isSplitView,
  jobId,
  returnUrl,
  toggleSavedJob,
}: SaveJobProps) =>
  isAuthenticated ? (
    <SaveJobForSignedIn
      isApplied={isApplied}
      isSaved={isSaved}
      isSplitView={isSplitView}
      jobId={jobId}
      toggleSavedJob={toggleSavedJob}
    />
  ) : (
    <SaveJobForSignedOut
      isSplitView={isSplitView}
      jobId={jobId}
      returnUrl={returnUrl}
      toggleSavedJob={toggleSavedJob}
    />
  );

export default memo(SaveJob);
